/** RollbackButton — confirm + delegate to parent for reauth + POST rollback. */
import React, { useState } from "react";
import { Button } from "../ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";
import { RotateCcw } from "lucide-react";

export default function RollbackButton({ previousVersion, disabled, onStartRollback }) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const noPrevious = !previousVersion;
  const btnDisabled = disabled || noPrevious;

  return (
    <>
      <Button
        variant="outline"
        disabled={btnDisabled}
        onClick={() => setConfirmOpen(true)}
        title={noPrevious ? "Aucune version antérieure disponible dans le journal" : ""}
        data-testid="btn-rollback"
      >
        <RotateCcw className="h-4 w-4 mr-2" /> Revenir à la version précédente
      </Button>
      <AlertDialog open={confirmOpen} onOpenChange={setConfirmOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Rollback vers {previousVersion}</AlertDialogTitle>
            <AlertDialogDescription>
              Cette opération va restaurer l'application dans son état antérieur. Elle nécessite une ré-authentification.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={() => { setConfirmOpen(false); onStartRollback?.(); }}>Continuer</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
